export enum ListStyleHint {
    BULLET = 'BULLET',
    NONE = 'NONE',
    NUMBER = 'NUMBER',
    UPPER_ALPHA = 'UPPER_ALPHA'
}
